import React, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import Navigation from 'components/navigation';
import CanvasView from '../canvasView';

const General = ({ data, result, step, setStep }) => {
  const canvasRef = useRef(null);
  const [check, setCheck] = useState([]);
  const [size, setSize] = useState({
    width: 500,
    height: 100,
  });
  const [next, setNext] = useState(false);
  const [inspOpt, setOption] = useState(null);
  
  const selectedItem = id => {
    
    let sideBar = document.getElementById("sidebarLeft");
    let hghVal = 0;
    for(let i = 0; i <= id; i++) {
      hghVal += sideBar.children[i].clientHeight + 39;
    }
    sideBar.scrollTo({
      top: hghVal,
      behavior: "smooth"
    });

    if (check.includes(id)) {
      setCheck(check.filter(item => item !== id));
    } else {
      setOption(id);
      setCheck([...check, id]);
    }
  };

  useEffect(() => {
    let mas = [];
    data &&
      data.generalModule.checklistData.forEach((item, index) => {
        if (item.isRightAnswer) {
          mas.push(index);
        }
      });
    if (
      mas.length === check.length &&
      mas.every(item => {
        return check.includes(item);
      })
    ) {
      setNext(true);
    } else {
      setNext(false);
    }
  }, [check]);

  const onWindowResize = () => {
    setSize({
      width: canvasRef.current.clientWidth,
      height: canvasRef.current.clientHeight,
    });
  };

  useEffect(() => {
    if (
      result &&
      result[
        data && data.generalModule.title
      ]
    ) {
      setCheck(
        result[
          data &&
            data.generalModule.title
        ].map(item => item - 1),
      );
    }
    onWindowResize();
  }, []);

  function GameInfo(props) {
    const {inspectOption} = props;
    // console.log('GameInfo', inspectOption);
// && data.generalModule.checklistData[inspectOption].info
      if (inspectOption !== null ) {
        return <div id="infoData" className="messages infoData">{data.generalModule.checklistData[inspectOption].info}</div>;
      } else {
        return <div id="infoData" className="messages infoData">{data && data.generalModule.info}</div>;
      }
    
  }


  return (
    <div className="general-wrapper">
      <h1 className="titile-step">
        {data &&
          data.generalModule.title}
      </h1>

      <Navigation
        step={step}
        setStep={setStep}
        next={next}
        answer={{
          [data &&
            data.generalModule.title]: check.map(item => item + 1),
        }}
      />
      
      <h2 className="step-number"></h2>
      <div className={classnames('modulesData-container', { up: step !== 4 })}>
      
        <div className="sidebar" id="sidebarLeft">
          {data &&
            data.generalModule.checklistData.map((item, index) => (
              <div key={index} className="sidebar-list">
                <div
                  className={classnames('checkbox', {
                    'checkbox-check': check.includes(index),
                  })}
                  onClick={() => selectedItem(index)}
                ></div>
                <div className="text">{index + 1 + '. ' + item.title}</div>
              </div>
            ))}
        </div>

        <div className="game-zone">

          <div className="canvas-wrapper">
            <CanvasView 
              ref={canvasRef} 
              width={size.width} 
              height={size.height}
              element={null}
              model={data && data.generalModule.canvasData.modelUrl}
              generalModule={true} 
            />
          </div>

          <div className="game-info">

          <GameInfo 
            inspectOption={inspOpt} 
          />

          </div>
        </div>
      </div>


    </div>
  );
};

export default General;
